import { createSlice } from "@reduxjs/toolkit";
import { getJapanDateTime } from "../../../../utils/datetimeutil";

export const stateBulletin = createSlice({
  name: "stateBulletin",
  initialState: {
    pageActive: JSON.parse(localStorage.getItem("pageActive")) || 1,
    pageCategoryActive: 1,
    folderActive: {
      folderName: JSON.parse(localStorage.getItem("folderActive") || "{}")?.folderName || null,
      folderUuid: JSON.parse(localStorage.getItem("folderActive") || "{}")?.folderUuid || null,
      key: JSON.parse(localStorage.getItem("folderActive") || "{}")?.key || null,
      value: JSON.parse(localStorage.getItem("folderActive") || "{}")?.value || null
    },
    files: [],
    systemUuid: JSON.parse(localStorage.getItem("systemUuid") || "{}") || null,
    bodySearch: (() => {
      const folderActive = JSON.parse(localStorage.getItem("folderActive") || "{}");
      const { key, value, folderUuid } = folderActive;
      if (key) {
        return {
          [key]: [{ keyword: value, condition: "EQ" }],
          ...(key === "read_flg" && {
            post_start_dt: [{ keyword: getJapanDateTime(), condition: "LTE" }, { condition: "NULL" }],
            post_end_dt: [{ keyword: getJapanDateTime(), condition: "GTE" }, { condition: "NULL" }]
          })
        };
      }

      // folderUuid === "KEEP_FLG"
      if (folderUuid === "KEEP_FLG") {
        return {
          keep_flg: [{ keyword: 1, condition: "EQ" }],
          post_start_dt: [{ keyword: getJapanDateTime(), condition: "LTE" }, { condition: "NULL" }],
          post_end_dt: [{ keyword: getJapanDateTime(), condition: "GTE" }, { condition: "NULL" }]
        };
      }

      // folder_uuid
      return {
        folder_uuid: [
          {
            keyword: folderUuid || null,
            condition: "EQ"
          }
        ],
        post_start_dt: [{ keyword: getJapanDateTime(), condition: "LTE" }, { condition: "NULL" }],
        post_end_dt: [{ keyword: getJapanDateTime(), condition: "GTE" }, { condition: "NULL" }]
      };
    })(),
    listBulletinStore: [],
    sorting: { key: "", direction: "" }
  },
  reducers: {
    setPageActive: (state, action) => {
      state.pageActive = action.payload;
      localStorage.setItem("pageActive", JSON.stringify(action.payload));
    },
    setPageCategoryActive: (state, action) => {
      state.pageCategoryActive = action.payload;
    },
    setFolderActive: (state, action) => {
      state.folderActive = action.payload;
      localStorage.setItem("folderActive", JSON.stringify(action.payload));
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    setBodySearch: (state, action) => {
      state.bodySearch = action.payload;
    },
    setSystemUuid: (state, action) => {
      state.systemUuid = action.payload;
      localStorage.setItem("systemUuid", JSON.stringify(action.payload));
    },
    setListBulletinStore: (state, action) => {
      state.listBulletinStore = action.payload;
    },
    setSorting: (state, action) => {
      state.sorting = action.payload;
    }
  }
});

export const {
  setPageActive,
  setFolderActive,
  setFiles,
  setBodySearch,
  setPageCategoryActive,
  setSystemUuid,
  setListBulletinStore,
  setSorting
} = stateBulletin.actions;

export default stateBulletin.reducer;
